import Schema from 'AppReact/schema';
import { orderEvent } from 'types';

export default {
  order_event: Schema(orderEvent, 'object', { defaultValue: {} }),
  events: Schema(orderEvent, 'array', { defaultValue: [] }),
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  translation: Schema("string", "primitive", { defaultValue: '' }),
  translated: Schema("boolean", "primitive", { defaultValue: false }),
  isEditMode: Schema('boolean', 'primitive', { defaultValue: false }),
  isActionDropdownOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  order_status: Schema('string', 'primitive', { defaultValue: '' }),
  order_id: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  request_id: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  edit_time_entry_allowed: Schema('boolean', 'primitive', { defaultValue: false }),
  order_eventIndex: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  startTimerWatch: Schema('string', 'primitive', { defaultValue: '' }),
  timerContainerRef: Schema({}, 'object', { defaultValue: null }), 
  prevTimerID: Schema('integer', 'primitive-nullable', { defaultValue: null }),
};
